module.exports = __webpack_public_path__ + "static/media/06.fb342936.svg";